<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar :key="componentKey"></sidebar>
    <div v-show="Isblur" class="splash"></div>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div class="card card-body card-panel-box border-0" style="    margin: 1vw .9vw;">
        <div class="col-lg-12">
          <div class="card card-body card-panel-box border-0">
            <div class="row d-flex justify-content-start">
              <h2 style="font-size: 1.2vw !important;width: 18vw;">سنجش رضایت ذی نفعان</h2>
              <hr>
            </div>
            <div v-if ="all_users.length > 0"  class="table-responsive mt-3">
              <div style="overflow-y: scroll; height: 35vw;" :style="all_users.length < 19 ? 'height: auto;' : ''">

                <table  class="table table-striped">
                  <thead>
                  <tr class="sticky-header">
                    <th>ردیف</th>
                    
                    <th style="width: 14vw;">ذی نفع</th>
                    <th>کد</th>
                    <th>پرسشنامه</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item, index) in all_users" :key="item.id">
                    <td scope="row">{{ index + 1 }}</td>
                    
                    <td>{{ item['title'] }}</td>
                    <td>{{ item['code'] }}</td>
                    <td> <a style="background: #3742fa;color: white;padding: 3px 5px;border-radius: 5px;font-size: 12px;" :href="`${this.download_url}/${item.questionnaire}`" target="_blank">دانلود</a></td>
                    
                  </tr>

                  </tbody>
                </table>

              </div>
            </div>

            <p style ="text-align: center;
    margin-top: 29px; " v-if ="all_users.length < 1"> ذی نفعی یافت نشد </p>
            <hr v-if ="all_users.length > 0" class="mt-3">
          </div>
        </div>
      </div>
    </div>
  </div>

  <UserCreateForm v-model="addModal" @user-created="handleUserCreated" @close-modal="closeUserCreateModal"/>

  <UserEditForm v-model="editModal" :user="userToEdit" @user-updated="handleUserUpdated " :posts="posts"
                @close-modal="closeUserUpdateModal"/>

  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999">
    <div>
      <p>حذف</p>
      <p @click="deleteModal=!deleteModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteItemForm(id)">تایید</button>
      </div>
    </div>
  </div>
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="showSign" style="z-index: 999999999999999">
    <div>
      <p>تصویر </p>
      <p @click="showSign=!showSign">❌</p>
    </div>
    <div>
      <img class=" img-fluid" style="height: 18vw; width: 18vw;" :src="`${this.download_url}/${img}`" alt="">


      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="showSign=!showSign" class="btn btn-primary btn-back" type="submit">برگشت</button>
      </div>
    </div>
  </div>

  <!-- !todo ************************************************ -->
  <div dir="rtl" class="modal__error slide-top" v-show="acceptCompleteModal"
       style="z-index: 999999999999999; top: 40%;">
    <div>
      <p>اخطار</p>
      <p @click="acceptCompleteModal=!acceptCompleteModal">❌</p>
    </div>
    <div>
      <p>آیا از ارائه به مدیر مطمئن هستید؟</p>
      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="acceptCompleteModal=!acceptCompleteModal" class="btn btn-primary btn-back" type="submit">برگشت
        </button>
        <button class="btn btn-primary btn-approve" @click="acceptComplete">تایید</button>
      </div>
    </div>
  </div>

  <div dir="rtl" class="modal__error slide-top" v-show="infoCancelled" style="z-index: 999999999999999; top: 40%;">
    <div>
      <p>عدم تایید</p>
      <p @click="infoCancelled=!infoCancelled">❌</p>
    </div>
    <div>
      <p>علت عدم تایید خود را بصورت کامل شرح دهید:</p>
      <textarea v-model="text_info" class="form-control" name="" id="" cols="30" rows="10"></textarea>
      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="infoCancelled=!infoCancelled" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="acceptComplete3">تایید</button>
      </div>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="infoCancelledModal" style="z-index: 999999999999999; top: 40%;">
    <div>
      <p>دلایل عدم تایید</p>
      <p @click="infoCancelledModal=!infoCancelledModal">❌</p>
    </div>
    <div>
      <div class="bg-white p-3 rounded w-100 text-right">
        <p>{{ textAlert }}</p>
      </div>
      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="showReSubmit=false" class="btn btn-primary btn-back" type="submit">برگشت</button>
      </div>
    </div>
  </div>

  <div dir="rtl" class="modal__error slide-top" v-show="showReSubmit" style="z-index: 999999999999999; top: 40%;">
    <div>
      <p>آیا مطمئن هستید تمامی موارد مشکل دار را رفع کرده اید؟</p>
      <p @click="showReSubmit=!showReSubmit">❌</p>
    </div>
    <div>
      <div class="bg-white p-3 rounded w-100 text-right">
        <p>{{ textAlert }}</p>
      </div>
      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="showReSubmit=false" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button @click="acceptComplete4" class="btn btn-primary btn-submit-1" type="submit">تایید نهایی</button>
      </div>
    </div>
  </div>


</template>

<script>
import Splash from "@/components/Splash/Splash";
import Sidebar from "@/components/Sidebar/Sidebar";
import Vue3PersianDatetimePicker from 'vue3-persian-datetime-picker'
import router from "@/router";
import {useToast} from "vue-toastification";
import UserCreateForm from "@/components/Users/UserCreateForm.vue";
import UserEditForm from "@/components/Users/UserEditForm.vue";

const toast = useToast();
export default {
  name: "ListUser",
  components: {UserEditForm, UserCreateForm, Sidebar, Splash, Vue3PersianDatetimePicker},
  data() {
    return {
      course_management: '',
      supplementary_date: '',
      supplementary_location: '',
      supplementary_certificate: '',
      intro_date: '',
      intro_location: '',
      intro_certificate: '',
      uni_dredge: '',
      work_history: '',
      id_user: '',
      //************************
      ErrorM: '',
      Error: false,
      showSign: false,
      img: '',
      deleteModal: false,
      loading: false,
      addModal: false,
      editModal: false,
      Isblur: false,
      roleOne: false,
      roleTwo: false,
      roleTree: false,
      infoCancelledModal: false,
      status_approver: false,
      // info models
      personalCode: '',
      fullname: '',
      username: '',
      password: '',
      componentKey: 0,
      firstname: '',
      lastname: '',
      start_date: '',
      end_date: '',
      phone: '',
      tel: '',
      tel_code: '',
      location_work: '',
      post: '',
      posts:[],
      note: '',
      // info rules one
      roleOne_one_viewer: false,
      roleOne_one_inserter: false,
      roleOne_one_submit: false,
      roleOne_one_management: false,
      roleOne_two_viewer: false,
      roleOne_two_inserter: false,
      roleOne_two_submit: false,
      roleOne_two_management: false,
      roleOne_tree_viewer: false,
      roleOne_tree_inserter: false,
      roleOne_tree_submit: false,
      roleOne_tree_management: false,
      // info rules two
      roleTwo_one_viewer: false,
      roleTwo_one_inserter: false,
      roleTwo_one_submit: false,
      roleTwo_one_management: false,
      roleTwo_two_viewer: false,
      roleTwo_two_inserter: false,
      roleTwo_two_submit: false,
      roleTwo_two_management: false,
      roleTwo_tree_viewer: false,
      roleTwo_tree_inserter: false,
      roleTwo_tree_submit: false,
      roleTwo_tree_management: false,
      roleTwo_four_viewer: false,
      roleTwo_four_inserter: false,
      roleTwo_four_submit: false,
      roleTwo_four_management: false,
      roleTwo_five_viewer: false,
      roleTwo_five_inserter: false,
      roleTwo_five_submit: false,
      roleTwo_five_management: false,
      roleTwo_six_viewer: false,
      roleTwo_six_inserter: false,
      roleTwo_six_submit: false,
      roleTwo_six_management: false,
      roleTwo_seven_viewer: false,
      roleTwo_seven_inserter: false,
      roleTwo_seven_submit: false,
      roleTwo_seven_management: false,
      // info rules tree
      roleTree_one_viewer: false,
      roleTree_one_inserter: false,
      roleTree_one_submit: false,
      roleTree_one_management: false,
      roleTree_two_viewer: false,
      roleTree_two_inserter: false,
      roleTree_two_submit: false,
      roleTree_two_management: false,
      roleTree_tree_viewer: false,
      roleTree_tree_inserter: false,
      roleTree_tree_submit: false,
      roleTree_tree_management: false,
      roleTree_four_viewer: false,
      roleTree_four_inserter: false,
      roleTree_four_submit: false,
      roleTree_four_management: false,
      roleTree_five_viewer: false,
      roleTree_five_inserter: false,
      roleTree_five_submit: false,
      roleTree_five_management: false,
      roleTree_six_viewer: false,
      roleTree_six_inserter: false,
      roleTree_six_submit: false,
      roleTree_six_management: false,
      // users
      all_users: [],
      id: 0,
      userToEdit: {},
      posts:[],
      searchUser: '',
      // middleware
      add_show: true,
      ED_show: false,
      active_show: false,
      show_list: false,
      organizational_route_show: false,
      ////*****************************************
      // Used in acceptComplete methods
      acceptCompleteModal: false,
      status_show: false,
      status_loading: false,
      infoCancelled: false,
      seconder_ban: false,
      approver_ban: false,
      showReSubmit: false,
      text_info: '',
      textAlert: '',


    }
  },
  methods: {
    fetchuser() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/user/show`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              this.logout()
              return;
            }
            if (result['item']) {
              if (this.is_mother) {
                this.id_user = result['item']['id']
                return;
              }
              this.id_user = result['item']['company_id']

            }

          })
          .catch();
    },
showImage(file) {
    if (!file) {
      toast.error('تصویری بارگذاری نشده است!');
      return;
    }

    

    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
    const fileExtension = file.split('.').pop().toLowerCase();

    if (imageExtensions.includes(fileExtension)) {
      this.img = file;
      this.showSign = true;
    } else {
      const fullPath = this.download_url +"/"+file;
      const link = document.createElement('a');
      link.href = fullPath;
      console.log(fullPath);
      link.download = '';
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
,

  isValidUrl(filePath) {
   if (!filePath) return false;
    const validExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'pdf', 'doc', 'docx']; // پسوندهای مجاز
    const ext = filePath.split('.').pop().toLowerCase();
    return validExtensions.includes(ext);
  },
    deleteItem(id, type) {
      if (type === 'تایید کننده') {
        toast.error('امکان حذف برای شما وجود ندارد!')
        return;
      }
      this.deleteModal = true
      this.id = id
    },
    deleteItemForm(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/user/delete/${id}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              this.Error = true
              this.ErrorM = result.error
            }
            this.deleteModal = false
            this.fetchItems()

          })
          .catch();
    },
    editMethod() {
      this.editModal = false
      this.Isblur = false
    },
    edit(id, type) {
      if (type === 'تایید کننده') {
        toast.error('امکان ویرایش برای شما وجود ندارد!')
        return;
      }

      this.editModal = true
      this.id = id

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/user/edit/${id}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            this.editModal = true
            this.Isblur = true
            this.id = id
            const item = result['item']
            if (item) {
              this.userToEdit = item
              this.allPosts()
            }

          })
          .catch();
    },

  allPosts() {
     
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/organization/post/all_tree`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result['all'].length !== 0) {
              this.posts.length=0
              result['all'].forEach(item => {
                this.posts.push(item)

              })

            }

          })
          .catch();
    },


    fetchItems() {
      this.all_users.length = 0
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/beneficiary/get_all`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result['data'].length !== 0) {
              result['data'].forEach(item => {
                this.all_users.push(item)

              })

            }

          })
          .catch();
    },
    resetAll() {
      this.uni_dredge = ''
      this.work_history = ''
      this.course_management = ''
      this.supplementary_date = ''
      this.supplementary_location = ''
      this.supplementary_certificate = ''
      this.intro_date = ''
      this.intro_location = ''
      this.intro_certificate = ''
      this.personalCode = ''
      this.fullname = ''
      this.username = ''
      this.firstname = ''
      this.lastname = ''
      this.password = ''
      this.start_date = ''
      this.end_date = ''
      this.phone = ''
      this.tel = ''
      this.tel_code = ''
      this.location_work = ''
      this.post = ''
      this.note = ''
      this.roleOne_one_viewer = false;
      this.roleOne_one_inserter = false;
      this.roleOne_one_submit = false;
      this.roleOne_one_management = false;
      this.roleOne_two_viewer = false;
      this.roleOne_two_inserter = false;
      this.roleOne_two_submit = false;
      this.roleOne_two_management = false;
      this.roleOne_tree_viewer = false;
      this.roleOne_tree_inserter = false;
      this.roleOne_tree_submit = false;
      this.roleOne_tree_management = false;
      this.roleTwo_one_viewer = false
      this.roleTwo_one_inserter = false
      this.roleTwo_one_submit = false
      this.roleTwo_one_management = false
      this.roleTwo_two_viewer = false
      this.roleTwo_two_inserter = false
      this.roleTwo_two_submit = false
      this.roleTwo_two_management = false
      this.roleTwo_tree_viewer = false
      this.roleTwo_tree_inserter = false
      this.roleTwo_tree_submit = false
      this.roleTwo_tree_management = false
      this.roleTwo_four_viewer = false
      this.roleTwo_four_inserter = false
      this.roleTwo_four_submit = false
      this.roleTwo_four_management = false
      this.roleTwo_five_viewer = false
      this.roleTwo_five_inserter = false
      this.roleTwo_five_submit = false
      this.roleTwo_five_management = false
      this.roleTwo_six_viewer = false
      this.roleTwo_six_inserter = false
      this.roleTwo_six_submit = false
      this.roleTwo_six_management = false
      this.roleTwo_seven_viewer = false
      this.roleTwo_seven_inserter = false
      this.roleTwo_seven_submit = false
      this.roleTwo_seven_management = false
      this.roleTree_one_viewer = false
      this.roleTree_one_inserter = false
      this.roleTree_one_submit = false
      this.roleTree_one_management = false
      this.roleTree_two_viewer = false
      this.roleTree_two_inserter = false
      this.roleTree_two_submit = false
      this.roleTree_two_management = false
      this.roleTree_tree_viewer = false
      this.roleTree_tree_inserter = false
      this.roleTree_tree_submit = false
      this.roleTree_tree_management = false
      this.roleTree_four_viewer = false
      this.roleTree_four_inserter = false
      this.roleTree_four_submit = false
      this.roleTree_four_management = false
      this.roleTree_five_viewer = false
      this.roleTree_five_inserter = false
      this.roleTree_five_submit = false
      this.roleTree_five_management = false
      this.roleTree_six_viewer = false
      this.roleTree_six_inserter = false
      this.roleTree_six_submit = false
      this.roleTree_six_management = false

    },
    addModalMethod() {
      this.resetAll();
      this.addModal = !this.addModal
      this.Isblur = !this.Isblur
    },
    _checking() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/user/check`, requestOptions)
          .then(response => response.json())
          .then(result => {


          })
          .catch();
    },
    checkIsMother() {
      if (this.is_mother) {
        router.push('/mother_items')
        return
      }

    },
    // Accept System
    acceptComplete() {
      this.acceptCompleteModal = false
      if (this.status_show) {
        return;
      }
      if (this.status_loading) {
        return;
      }
      if (!this.infoCancelled) {
        if (this.$cookies.isKey('type_1')) {
          if (this.status_show) {
            this.text_info = ''
            this.infoCancelled = true
            return;
          }
        }
      }
      if (this.seconder_ban || this.approver_ban) {
        this.showReSubmit = true
        return;
      }
      this.status_loading = true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info) {
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Prioritizing_Issue/update_complete`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              this.status_loading = false
              return
            }
            if (response.message) {
              toast.success(response.message)
              this.status_show = !this.status_show
              this.status_loading = false
              this.all()
            }
            this.infoCancelled = false
          })
          .catch();
    },
    acceptComplete4() {
      this.status_loading = true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info) {
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Prioritizing_Issue/update_complete`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              this.status_loading = false
              return
            }
            if (response.message) {
              toast.success(response.message)
              this.status_show = !this.status_show
              this.status_loading = false
              this.all()
            }
            this.infoCancelled = false
            this.showReSubmit = false
          })
          .catch();
    },
    acceptComplete2() {
      if (this.status_loading) {
        return;
      }
      if (!this.infoCancelled) {
        if (this.$cookies.isKey('type_1')) {
          if (this.status_show) {
            this.text_info = ''
            this.infoCancelled = true
            return;
          }
        }
      }
      this.infoCancelled = true
    },
    acceptComplete3() {
      this.status_loading2 = true
      if (!this.status_show) {
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
        var formdata = new FormData();
        if (this.text_info) {
          formdata.append('text', this.text_info)
        }
        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        };
        fetch(`${this.base_url}/Prioritizing_Issue/update_complete`, requestOptions)
            .then(response => response.json())
            .then(response => {


            })
            .catch();
      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info) {
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Prioritizing_Issue/update_complete`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              this.status_loading2 = false
              return
            }
            if (response.message) {
              toast.success(response.message)
              this.status_show = !this.status_show
              this.status_loading2 = false
              this.all()
            }
            this.infoCancelled = false

          })
          .catch();
    },

    handleUserCreated() {
      this.all_users.length = 0;
      this.fetchItems();
      this.closeUserCreateModal();
    },
    closeUserCreateModal() {
      this.resetAll();
      this.addModal = false;
      this.Isblur = false;
    },
    handleUserUpdated() {
      this.all_users.length = 0;
      this.fetchItems();
      this.closeUserUpdateModal();
    },
    closeUserUpdateModal() {
      this.resetAll();
      this.editModal = false;
      this.Isblur = false;
    },
  },
  mounted() {
    this.fetchuser()
    this.fetchItems()
    this.checkIsMother()
    this._checking()
  },
  computed: {
    // filteredItems() {
    //   return this.all_users.filter(item => {
    //     return (
    //         item['personal_code'].includes(this.searchUser) || item['fullname'].includes(this.searchUser)
    //     );
    //   });
    // },
  }
}
</script>

<style scoped lang="scss">
label {
  width: 100%;
  text-align: right;
}

p, label {
  font-size: 1vw !important;
}

input[type=checkbox] {
  width: 1vw;
  height: 1vw;
  border-radius: .5vw;
  border: .2vw solid #eee;
}

.text-end {
  font-weight: bold;
}

.change_div {
  background: #fff;
  width: 20vw;
  padding: 1vw;
  margin-left: 5vw;
  border-radius: 1vw;
}

.img-button {
  width: 4.5vw;
}

.btn-success{
display: flex
;
    width: 4.5vw;
    height: 1.6vw;
    padding: 0vw 0vw 0vw 0vw;
    justify-content: center;
    align-items: center;
    border-radius: 0.5vw;
    background: #23973c;
    border-color: #45ce45;
    box-shadow: 0vw 14vw 23vw 0vw rgba(28, 37, 44, 0.08);
    color: #FFFFFF;
    text-align: center;
    font-size: 0.85vw;
    font-style: normal;
    font-weight: 400;
    line-height: 4.5vh
18.05px
;

}
</style>
